import YourCardsActiveReducer, {
  Actions as YourCardsActiveActions,
  initialState as initialYourCardsActiveState,
  YourCardsActiveState,
} from 'src/app/YourCardsActive/redux/yourCardsActive.reducer'
import YourCardsInactiveReducer, {
  Actions as YourCardsInactiveActions,
  initialState as initialYourCardsInactiveState,
  YourCardsInactiveState,
} from 'src/app/YourCardsInactive/redux/yourCardsInactive.reducer'

export type YourCardsState = {
  yourCardsActive: YourCardsActiveState
  yourCardsInactive: YourCardsInactiveState
}

export const initialState: YourCardsState = {
  yourCardsActive: initialYourCardsActiveState,
  yourCardsInactive: initialYourCardsInactiveState,
}

export type Actions = YourCardsActiveActions | YourCardsInactiveActions

const YourCardsReducer = (
  state = initialState,
  action: Actions,
): YourCardsState => ({
  yourCardsActive: YourCardsActiveReducer(
    state.yourCardsActive,
    action as YourCardsActiveActions,
  ),
  yourCardsInactive: YourCardsInactiveReducer(
    state.yourCardsInactive,
    action as YourCardsInactiveActions,
  ),
})

export default YourCardsReducer
